import React from 'react'
import { Stack, SimpleTabs } from '@/components/lib'

import useStore from '../../../store'
import utils from '../../../utils/utils'
import useTitle from '../../../hooks/useTitle'
import Dashboards from './Dashboards'
import Explore from './Explore'
import Export from './Export'
import Integrations from './Integrations'

export default function Results () {
  const { user, trial } = useStore()
  useTitle('Results', trial)
  // Tabs are addressable, so a page can be linked to directly and an OAuth
  // connection can send the user back to the tab they started from.
  const base = `/trials/${trial?._id}/results`
  return (
    <Stack gap={5}>
      <SimpleTabs
        tabs={[
          { title: 'Dashboards', to: `${base}/dashboards`, content: <Dashboards /> },
          { title: 'Explore', to: `${base}/explore`, content: <Explore /> },
          utils.canExportData(user, trial) && { title: 'Export', to: `${base}/export`, content: <Export /> },
          // Integrations set up an ongoing external data sync — an admin-gated
          // action (can_manage_trial), so only surface the tab to admins.
          utils.canManageTrial(user, trial) && { title: 'Integrations', to: `${base}/integrations`, content: <Integrations /> }
        ]}
      />
    </Stack>
  )
}
